module.exports = __webpack_public_path__ + "static/media/logo_appartenances.664ceb3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo_appartenances.svg
// module id = 439
// module chunks = 0